import { Component, OnInit, Input, Inject, Output, EventEmitter, ViewChild } from "@angular/core";
import { CustomersService } from "./../../../services/customers.service";
import { CustomersFilters } from "./../../../model/customers";
import { TrucksService } from "../../../services/trucks.service";
import { TrailerService } from "../../../services/trailers.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatStepper} from "@angular/material/stepper";
import { AttachmentsComponent } from "../attachments/attachments.component";
import { AttachmentsService } from "../../../services/attachments.service";
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { SetupDataService } from "../../../services/setupdata.service";
import { DxDataGridComponent } from "devextreme-angular";
@Component({
  selector: "app-customerform",
  templateUrl: "./customerform.component.html",
  styleUrls: ["./customerform.component.scss"],
  providers: [CustomersService, TrucksService, TrailerService, SetupDataService ],
})
export class CustomerformComponent implements OnInit {

  pageFilters :any = { name: "" };
  public customers: CustomersFilters;
  Customerslistdata = new Array<CustomersFilters>();
  contactInfo = [];
  @Input() data;
  @Input() disableClose;
  @Output() newItemEvent = new EventEmitter<string>();
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  mode = false;
  finalArry = [];
  pageFiltersshow = false;
  submitted = false;
  contactInfoData = {};
  showAddOption = false;
  fileArray = [];
  base64FileArray = [];
  item = "";
  filedata = {};
  showviewedit = false;
  selectedCustomer = true;
  showupdate = false;
  showsubmit = false;
  changeUplaod = true;
  editFileList = [];
  btnHide = false;
  CustomerlistdataId;
  customerFormdata;
  paymentTermsList:any[] = [];
  customerForm: FormGroup;


  SearchCountryField = SearchCountryField;

  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.India];
  selectedCellPhoneCountry = "US";
  showCustomerGoogleAddress = "";
  showBillingGoogleAddress = "";
  customerId;
  submittedLast = false;

  constructor(
    // public dialogRef: MatDialogRef<CustomerformComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private _customersservice: CustomersService,
    private _trailersService: TrailerService,
    private _trucksservice: TrucksService,
    private _toaster: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private _attachementService: AttachmentsService,
    private _setupdataService: SetupDataService,
  ) { }

  ngOnInit() {
    if (this.data == undefined || this.data["EditMode"] == undefined) {
      this.mode = true;
      this.showAddOption = true;
      this.selectedCustomer = false;
      this.showsubmit = true;
      this.pageFilters["address"] = {};
      this.pageFilters["address1"] = {};
    } else {
      this.mode = this.data["EditMode"];
      this.pageFilters = this.data;
      this.showAddOption = this.data["EditMode"];
      this.contactInfo = this.data.contactInfoData;
      this.changeUplaod = false;
      this.fileArrayLocal = this.data["files"];
      if (this.data["EditMode"]) {
        this.showupdate = true;
        this.editFileList = this.data["files"];
      }

      if (this.data["cellPhone"] != undefined) {
        this.selectedCellPhoneCountry = this.data["cellPhone"]["countryCode"];
      }
      if (this.data["CustomerAddress"] != undefined) {
        this.showCustomerGoogleAddress = this.data["CustomerAddress"]["fullAddress"];
      }
      if (this.data["BillingAddress"] != undefined) {
        this.showBillingGoogleAddress = this.data["BillingAddress"]["fullAddress"];
      }
    }
    this.pageFiltersshow = true;
    this._setupdataService.getBCPaymentTerms().subscribe((data) => {
      this.paymentTermsList = data.result;
      if (this.data == undefined || this.data["EditMode"] == undefined){
        // set default payment term as 30 days
        //  find the payment term with name "30 DAYS"
        let paymentTerm = this.paymentTermsList.find(term => term.Code === "Net 30");
        let defaultPaymentTerm = "30 DAYS";
        if (paymentTerm) {
          defaultPaymentTerm = paymentTerm.Code;
        }
        this.pageFilters["paymentTerms"] = defaultPaymentTerm;
      }
    });

  }

  selectedCustomerAddress;
  selectedBillingAddress
  getCustomerGoogleAddress($event) {
    this.selectedCustomerAddress = $event
    console.log(this.selectedCustomerAddress);
  }

  getBillingGoogleAddress($event) {
    this.selectedBillingAddress = $event
    console.log(this.selectedBillingAddress);
  }

  addRow(){
    this.grid.instance.addRow();
    this.grid.instance.deselectAll();
  }
  hidePopup() {
    if (this.submitted) {
      this.submitClicked = false;
      // this.dialogRef.close(true);
    } else {
      let companyName = localStorage
        .getItem("selectedCompanyName")
        .toLowerCase()
        .split(" ")
        .join("_");
      let formName = "Customer";
      if (this.filesChanged) {
        if (this.showsubmit) {
          this.fileArrayLocal.forEach((item, index) => {
            this._attachementService
              .deleteFile(companyName, formName, item.fileName)
              .subscribe(
                (response) => { },
                (err) => {
                  this._toaster.error("Files deletion failed.", "Failed", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: true,
                  });
                }
              );
          });
        }
        else if (this.showupdate) {
          let obj = {};
          obj["files"] = this.fileArrayLocal;
          this._customersservice
            .EditCustomers(obj, this.data["_id"])
            .subscribe(
              (res) => {
                this.btnHide = false;
                // this.dialogRef.close(res);
              },
              (error) => {
                this._toaster.error("Customer Data Not Updated", "Failed", {
                  disableTimeOut: true,
                  tapToDismiss: false,
                  closeButton: true,
                });
                // this.dialogRef.close(null);
              }
            );

        }
      }
      // this.dialogRef.close(null);
    }
  }


  goBack() {
    this.newItemEvent.emit();
  }
  update(customerForm) {
    if (customerForm.valid) {
      if(this.data["_id"] != undefined) {
        this.customerId = this.data["_id"];
      }
      else{
        this.data["_id"] = this.customerId;
      }

      this.data["files"] = this.fileArrayLocal;
      this.data["contactInfoData"] = this.contactInfo;

      if (this.selectedCustomerAddress != undefined) {
        this.data["CustomerAddress"] = this.selectedCustomerAddress;
      }

      if (this.selectedBillingAddress != undefined) {
        this.data["BillingAddress"] = this.selectedBillingAddress;
      }

      delete this.data["companyId"];
      delete this.data["createdAt"];
      delete this.data["updatedAt"];
      delete this.data["EditMode"];
      console.log(this.data);
      // if (
      //   this.pageFilters["mcff"] != undefined &&
      //   this.pageFilters["mcff"] != ""
      // ) {
        this.btnHide = true;
        this._customersservice
          .EditCustomers(this.data, this.data["_id"])
          .subscribe(
            (res) => {
              this._toaster.info(
                "Customer Data Updated successfully",
                "Success",
                { timeOut: 1000 }
              );
              this.data["_id"] = this.customerId;
              this.btnHide = false;
              this.goBack();
              // this.dialogRef.close(res);
            },
            (error) => {
              this.data["_id"] = this.customerId;
              this._toaster.error("Customer Data Not Updated", "Failed", {
                disableTimeOut: true,
                tapToDismiss: false,
                closeButton: true,
              });
              // this.dialogRef.close(null);
            }
          );
      // } else {
      //   this._toaster.error("Enter MC Details", "Failed", { timeOut: 1000 });
      // }
    } else {
      /* this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(customerForm.controls)
    }
  }

  submitClicked = false;

  submit(customerForm) {
    this.submitClicked = true;
    if (customerForm.valid) {
      if (localStorage.selectedCompany == undefined) {
        this._toaster.error("Please Select Company", "Failed", {
          disableTimeOut: true,
          tapToDismiss: false,
          closeButton: true,
        });
      } else {
        var Customerslistdata: any = this.pageFilters;
        Customerslistdata["companyId"] = localStorage.selectedCompany;
        Customerslistdata["contactInfoData"] = this.contactInfo;
        Customerslistdata["allowAccess"] = this.pageFilters["allowAccess"];
        Customerslistdata["files"] = this.fileArrayLocal;
        var addobj = {};
        addobj["line"] = Customerslistdata["address"]["line"];
        addobj["line1"] = Customerslistdata["address"]["line1"];
        addobj["city"] = Customerslistdata["address"]["city"];
        addobj["state"] = Customerslistdata["address"]["state"];
        addobj["zip"] = Customerslistdata["address"]["zip"];
        delete Customerslistdata["address3"];
        delete Customerslistdata["address4"];
        delete Customerslistdata["city1"];
        delete Customerslistdata["state1"];
        delete Customerslistdata["zipcode1"];
        Customerslistdata["address"] = addobj;

        var addobj1 = {};
        addobj1["line"] = Customerslistdata["address1"]["line"];
        addobj1["line1"] = Customerslistdata["address1"]["line1"];
        addobj1["city"] = Customerslistdata["address1"]["city"];
        addobj1["state"] = Customerslistdata["address1"]["state"];
        addobj1["zip"] = Customerslistdata["address1"]["zip"];
        delete Customerslistdata["address1"];
        delete Customerslistdata["address2"];
        delete Customerslistdata["city"];
        delete Customerslistdata["state"];
        delete Customerslistdata["zipcode"];
        Customerslistdata["address1"] = addobj1;

        if (this.selectedCustomerAddress != undefined) {
          Customerslistdata["CustomerAddress"] = this.selectedCustomerAddress;
        }

        if (this.selectedBillingAddress != undefined) {
          Customerslistdata["BillingAddress"] = this.selectedBillingAddress;
        }

        Customerslistdata["_id"] = this.CustomerlistdataId;
          this.btnHide = true;
          this.submittedLast = true;
          if (this.CustomerlistdataId != undefined) {
            delete Customerslistdata["companyId"];
            this._customersservice
              .EditCustomers(Customerslistdata, Customerslistdata["_id"])
              .subscribe(
                (response) => {
                  if (response.Status != "error") {
                    this.submitted = true;
                    this._toaster.info(
                      "Customerform Data Submitted",
                      "Success",
                      {
                        timeOut: 1000,
                      }
                    );
                    this.btnHide = false;
                    this.goBack();
                    // this.dialogRef.close(response);
                  } else {
                    this.submitted = false;
                    this._toaster.info(response.error, "Failed", {
                      disableTimeOut: true,
                      tapToDismiss: false,
                      closeButton: true,
                    });
                  }
                },
                (error) => {
                  this.submitted = false;
                  this._toaster.error("Submit again", "Failed", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: true,
                  });
                }
              );
          } else {
            this._customersservice.SendForm(Customerslistdata).subscribe(
              (response) => {
                if (response.Status != "error") {
                  this.submittedLast = true;
                  this._toaster.info("Customerform Data Submitted", "Success", {
                    timeOut: 1000,
                  });

                  this.btnHide = false;
                  this.CustomerlistdataId = response["result"]["_id"];
                  this.goBack();
                  // this.dialogRef.close(response);
                } else {
                  this.submittedLast = false;
                  this._toaster.info(response.error, "Failed", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: true,
                  });
                }
              },
              (error) => {
                this.submittedLast = false;
                if (error._body.includes("email")) {
                  this._toaster.error(JSON.parse(error._body).error, "Failed", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: true,
                  });
                } else {
                  this._toaster.error("Something went wrong. Try again!!", "Failed", {
                    disableTimeOut: true,
                    tapToDismiss: false,
                    closeButton: true,
                  });
                }
              }
            );
          }
      }
    } else {
      /* this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(customerForm.controls);
    }
  }
  submitpart1(customerForm, stepper:MatStepper) {
    this.submitClicked = true;
    if (customerForm.valid) {
      console.log(this.pageFilters);
      var customerFormdata: any = this.pageFilters;
      this.pageFilters["companyId"] = localStorage.selectedCompany;
      customerFormdata["mcff"] = this.pageFilters["mcff"];
      customerFormdata["name"] = this.pageFilters["name"];
      customerFormdata["companyId"] = this.pageFilters["companyId"];
      customerFormdata["contactInfoData"] = this.contactInfo;
      customerFormdata["files"] = this.fileArrayLocal;
      var addobj = {};
      addobj["line"] = customerFormdata["address"]["line"];
      addobj["line1"] = customerFormdata["address"]["line1"];
      addobj["city"] = customerFormdata["address"]["city"];
      addobj["state"] = customerFormdata["address"]["state"];
      addobj["zip"] = customerFormdata["address"]["zip"];
      delete customerFormdata["address3"];
      delete customerFormdata["address4"];
      delete customerFormdata["city1"];
      delete customerFormdata["state1"];
      delete customerFormdata["zipcode1"];
      customerFormdata["address"] = addobj;

      var addobj1 = {};
      addobj1["line"] = customerFormdata["address1"]["line"];
      addobj1["line1"] = customerFormdata["address1"]["line1"];
      addobj1["city"] = customerFormdata["address1"]["city"];
      addobj1["state"] = customerFormdata["address1"]["state"];
      addobj1["zip"] = customerFormdata["address1"]["zip"];
      delete customerFormdata["address1"];
      delete customerFormdata["address2"];
      delete customerFormdata["city"];
      delete customerFormdata["state"];
      delete customerFormdata["zipcode"];
      customerFormdata["address1"] = addobj1;

      if (this.selectedCustomerAddress != undefined) {
        customerFormdata["CustomerAddress"] = this.selectedCustomerAddress;
      }

      if (this.selectedBillingAddress != undefined) {
        customerFormdata["BillingAddress"] = this.selectedBillingAddress;
      }

      this.btnHide = true;
      this.submitted = true;
      this._customersservice.SendForm(customerFormdata).subscribe(
        (response) => {
          if (response.Status != "error") {
            this.submitted = true;
            this._toaster.info("Customerform Data Submitted", "Success", {
              timeOut: 1000,
            });
            this.btnHide = false;
            stepper.selectedIndex = stepper.selectedIndex+1;
              // stepper.linear = true;
            this.CustomerlistdataId = response["result"]["_id"];
            console.log(this.CustomerlistdataId);
          } else {
            this.submitted = false;
            this._toaster.info(response.error, "Failed", {
              disableTimeOut: true,
              tapToDismiss: false,
              closeButton: true,
            });
          }
        },
        (error) => {
          this.submitted = false;
          if (error._body.includes("email")) {
            this._toaster.error(JSON.parse(error._body).error, "Failed", {
              disableTimeOut: true,
              tapToDismiss: false,
              closeButton: true,
            });
          } else {
            this._toaster.error("Something went wrong. Try again!!", "Failed", {
              disableTimeOut: true,
              tapToDismiss: false,
              closeButton: true,
            });
          }
        }
      );
    }
    else {
      this.onFromValidation(customerForm.controls)
      // this._toaster.error("Please fix the validations", "Failed", {
      //   disableTimeOut: true,
      //   tapToDismiss: false,
      //   closeButton: true,
      // });
    }
  }
  onFromValidation(formData) {
    let check = false;
    let timeout = 3000;
    this._toaster.clear()
    Object.keys(formData).forEach((key) => {
      // if (check) {
      //   return;
      // }
      if (formData[key].errors) {
        if (key === "name") {
          this._toaster.error("Customer name is Required", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
          check = true;
        }
        else if (key === "mcff") {
          this._toaster.error("Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
          check = true;
        }
        else if (key === "cellPhone") {
          if(formData[key].errors.validatePhoneNumber){
            this._toaster.error("Cell phone is invalid", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("Cell phone is Required", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "email") {
          this._toaster.error("Email ID is invalid", "Failed",{
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
          check = true;
        }
        else if (key === "dba") {
          if(formData[key].errors.pattern){
            this._toaster.error("DBA - Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "usdot") {
          if(formData[key].errors.pattern){
            this._toaster.error("US DOT - Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "dotNumber") {
          if(formData[key].errors.pattern){
            this._toaster.error("DOT Number- Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "mcNumber") {
          if(formData[key].errors.pattern){
            this._toaster.error("MC Number- Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "billTo") {
          if(formData[key].errors.pattern){
            this._toaster.error("Bill to - Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
          else if(formData[key].errors.maxLength){
            this._toaster.error("Bill to - Max of 6 characters are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else if (key === "customerAccount") {
          if(formData[key].errors.pattern){
            this._toaster.error("Customer Account - Only Alphanumeric values are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
          else if(formData[key].errors.maxLength){
            this._toaster.error("Customer Account - Max of 10 characters are allowed", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
            check = true;
          }
        }
        else {
          this._toaster.error("Please fix the validations", "Failed", {
            disableTimeOut: true,
            tapToDismiss: false,
            closeButton: true,
          });
          check = true;
        }
      }
    });
  }
  reset() { }
  uploadedFiles: File[] = [];
  filesChanged = false;
  fileArrayLocal = [];
  attachementData = {};

  openAttachments() {
    this.attachementData["fileInfo"] = this.fileArrayLocal;
    if (this.showsubmit || this.showupdate) {
      this.attachementData["mode"] = true;
    }
    this.attachementData["model"] = "Customer";
    let dialogConfig = Object.assign(
      { width: "1000px" },

      { data: this.attachementData },
      { disableClose: true }
    );
    let dialogRef = this.dialog.open(AttachmentsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((attachmentData) => {
      console.log(attachmentData);
      this.fileArrayLocal = attachmentData.fileInfo;
      this.uploadedFiles = attachmentData.uploadedFiles;
      this.filesChanged = attachmentData.filesChanged;

    });
  }
  ngOnDestroy(){
    let toasts =  []
    this._toaster.toasts.forEach( (ele)=>{
      if(ele.title == "Failed"){
        this._toaster.clear(ele.toastId)
      }
    })
  }
}
